import React from 'react';
import { MdOutlineFileDownload } from 'react-icons/md';
import { RxCross2 } from 'react-icons/rx';

export default function ImageViewer({ base64, fileName, setViewImage }) {
    const downloadImage = () => {
        const link = document.createElement('a');
        link.href = base64;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <div className='d-flex justify-content-center align-items-center' style={{ backgroundColor: 'black', height: "90%", width: "100%", position: 'absolute', padding: '20px', zIndex: '999999999999999999' }}>

            <div style={{
                position: 'absolute',
                top: '10px',
                right: '10px',
                color: 'white',
                border: 'none',
                padding: '10px',
                cursor: 'pointer'
            }}
                className='d-flex gap-3 align-items-center'
            >
                <MdOutlineFileDownload onClick={downloadImage} style={{ height: "30px", width: "30px" }} />
                <RxCross2 style={{ height: "30px", width: "30px" }} onClick={() => setViewImage(null)} />
            </div>
            <img src={base64} alt={fileName} style={{ maxWidth: "80%", maxHeight: "80%", backgroundSize: "cover" }} />
        </div>
    );
}